var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMinimize = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 1 0-16 0m-2 0C0 4.477 4.477 0 10 0s10 4.477 10 10M2 10a8 8 0 1 0 16 0m2 0c0 5.523-4.477 10-10 10S0 15.523 0 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.824 10.859h8.352a.859.859 0 1 0 0-1.718H5.824a.859.859 0 1 0 0 1.718z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMinimize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-minimize.441409cbdaba202b2d46195e5b6bb59b.svg";